export type TagClickType = 'business_tags' | 'tech_tags' | 'resources';

export interface ResourceTagItem {
  attributes: {
    name: string;
    query: string;
  };
}

export const STATIC_RESOURCE_TAGS: ResourceTagItem[] = [
  { attributes: { name: 'Case Studies', query: 'customer-case-studies' } },
  { attributes: { name: 'External Publications', query: 'customer-external-publications' } },
  { attributes: { name: 'TL Articles', query: 'customer-tl-articles' } },
  { attributes: { name: 'Clutch reviews', query: 'customer-clutch-reviews' } },
  { attributes: { name: 'Pitchdeck Brochures', query: 'customer-pitch-decks' } },
  { attributes: { name: 'Testimonials', query: 'customer-testimonials' } },
];

export const EXTRA_TECH_TAGS = ['Blockchain', 'Bigdata'];
